module.exports = __webpack_public_path__ + "static/media/hacs-logo-white-fill.3362a2a9.png";